import React, { useContext, useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Accordion, Button } from "react-bootstrap";
import AccordionContext from 'react-bootstrap/AccordionContext';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import { getSideBarRoutes, Utils } from '../../Utils/index';
import { getItem } from "../../Services/localService";
import { LuLogOut, LuPlusSquare } from "react-icons/lu";
import { IoCaretDownOutline, IoCaretForwardOutline, IoCloseOutline } from "react-icons/io5";
import { TbSquareArrowLeft, TbSquareArrowRight } from "react-icons/tb";
// import { ReactComponent as HomeIcon } from "../../Assets/images/sidebar/home-icon.svg";
import { ReactComponent as DashboardIcon } from "../../Assets/images/sidebar/icons/dashboard-icon.svg";
import { ReactComponent as MarketingIcon } from "../../Assets/images/sidebar/icons/marketing-icon.svg";
import { ReactComponent as DataHubIcon } from "../../Assets/images/sidebar/icons/data-hub-icon.svg";
import { ReactComponent as ProspectusIcon } from "../../Assets/images/sidebar/icons/prospects-icon.svg";
import { ReactComponent as CampaignIcon } from "../../Assets/images/sidebar/icons/campaign-icon.svg";
import { ReactComponent as SalesIcon } from "../../Assets/images/sidebar/icons/sales-icon.svg";
import { ReactComponent as QuotesIcon } from "../../Assets/images/sidebar/icons/quotes-icon.svg";
import { ReactComponent as SalesPlanIcon } from "../../Assets/images/sidebar/icons/sales-plan-icon.svg";
import { ReactComponent as LeadsIcon } from "../../Assets/images/sidebar/icons/leads-icon.svg";
import { ReactComponent as AccountsIcon } from "../../Assets/images/sidebar/icons/accounts-icon.svg";
import { ReactComponent as ContactsIcon } from "../../Assets/images/sidebar/icons/contacts-icon.svg";
import { ReactComponent as DealsIcon } from "../../Assets/images/sidebar/icons/deals-icon.svg";
import { ReactComponent as ActivitiesIcon } from "../../Assets/images/sidebar/icons/activities-icon.svg";
import { ReactComponent as TasksIcon } from "../../Assets/images/sidebar/icons/tasks-icon.svg";
import { ReactComponent as CallsIcon } from "../../Assets/images/sidebar/icons/calls-icon.svg";
import { ReactComponent as MeetingsIcon } from "../../Assets/images/sidebar/icons/meeting-icon.svg";
import { ReactComponent as O2cIcon } from "../../Assets/images/sidebar/icons/o2c-icon.svg";
import { ReactComponent as SalesOrderIcon } from "../../Assets/images/sidebar/icons/sales-order-icon.svg";
import { ReactComponent as InvoicesIcon } from "../../Assets/images/sidebar/icons/invoices-icon.svg";
import { ReactComponent as ServicesIcon } from "../../Assets/images/sidebar/icons/services-icon.svg";
import { ReactComponent as CasesIcon } from "../../Assets/images/sidebar/icons/cases-icon.svg";
import { ReactComponent as MasterIcon } from "../../Assets/images/sidebar/icons/master-icon.svg";
import { ReactComponent as ProductMasterIcon } from "../../Assets/images/sidebar/icons/product-master-icon.svg";
import { ReactComponent as PriceBookIcon } from "../../Assets/images/sidebar/icons/price-book-icon.svg";
import { getAllFormModuleStart, getAllFormModuleTableDataStart } from "../../Store/Slices/formSlice";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import CreateSectionModal from "../../Pages/FormModule/CreateSectionModal";
import { createSidebarSectionStart, getSidebarSectionListStart } from "../../Store/Slices/sidebarSlice";
import Loader from "../Loader";
import { toast } from "react-toastify";
import Toast from "../Toast";

function ContextAwareToggle({ name, children, eventKey, showNav, onHover, onLeave, onClickPin, isFlyoutActive, isActive, setActiveKey, activeKey }) {
    let navigate = useNavigate();
    const { activeEventKey } = useContext(AccordionContext);
    const decoratedOnClick = useAccordionButton(eventKey);

    const isAccordionActive = activeEventKey === eventKey;
    // const isActive = showNav ? isAccordionActive : isFlyoutActive;
    const finalActiveState = isActive || (showNav ? isAccordionActive : isFlyoutActive);

    // const isOpen = activeEventKey === eventKey;

    const handleClick = () => {
        if (name === 'Dashboard') {
            navigate(Utils.getNavigationUrl(`dashboard`));
            setActiveKey(null);
        } else {
            if (!showNav) {
                onClickPin(eventKey);
            } else {
                const newKey = activeKey === eventKey.toString() ? null : eventKey.toString();
                setActiveKey(newKey);
                decoratedOnClick();
            }
        }
    };

    return (
        <Button
            variant="link"
            className={`
                link-dark d-flex w-100 px-2 nav_link justify-content-center mb-1
                ${finalActiveState ? 'active' : 'in-active'}
            `}
            // className={`link-dark d-flex w-100 px-2 nav_link justify-content-center mb-3 ${isOpen 
            //     ? 'active' : 'in-active'
            // }`}
            onClick={handleClick}
            onMouseEnter={() => !showNav && onHover(eventKey)}
            onMouseLeave={() => !showNav && onLeave()}
        >
            {(showNav && name !== 'Dashboard') && (isAccordionActive ? <IoCaretDownOutline /> : <IoCaretForwardOutline />)}
            {children}
        </Button>
    );
};

export const SECTION_ICON_MAP = {
    Dashboard: DashboardIcon,
    Sales: SalesIcon,
    Activities: ActivitiesIcon,
    O2C: O2cIcon,
    Services: ServicesIcon,
    Master: MasterIcon,
    Marketing: MarketingIcon
};

export const ITEM_ICON_MAP = {
    Quotes: QuotesIcon,
    "Sales Plan": SalesPlanIcon,
    Leads: LeadsIcon,
    Accounts: AccountsIcon,
    Contacts: ContactsIcon,
    Deals: DealsIcon,
    Campaigns: CampaignIcon,
    Prospects: ProspectusIcon,
    Meetings: MeetingsIcon,
    Calls: CallsIcon,
    Tasks: TasksIcon,
    Invoices: InvoicesIcon,
    "Sales Orders": SalesOrderIcon,
    "Cases ": CasesIcon,
    "Price Books": PriceBookIcon,
    Products: ProductMasterIcon
};

// export const getSectionIcon = (name) => {
//     const Icon = SECTION_ICON_MAP[name] || DashboardIcon;
//     return Icon ? <Icon width={20} height={20} /> : null;
// };

// export const getItemIcon = (name) => {
//     const Icon = ITEM_ICON_MAP[name] || DashboardIcon;
//     return Icon ? <Icon width={20} height={20} className="nav_icon" /> : null;
// };

export const getSectionIcon = (icon, color) => {
    if (!icon) return null;
    if (color) {
        return <div
            style={{
                width: 20,
                height: 20,
                backgroundColor: color,
                maskImage: `url(${icon})`,
                WebkitMaskImage: `url(${icon})`,
                maskRepeat: "no-repeat",
                WebkitMaskRepeat: "no-repeat",
                maskSize: "contain",
                WebkitMaskSize: "contain"
            }}
        />

    } else {
        return <img src={icon} alt="section-icon" width={20} height={20} className="nav_icon" />
    }
};

export const getItemIcon = (icon, color) => {
    if (!icon) return null;
    if (color) {
        return <div
            style={{
                width: 20,
                height: 20,
                backgroundColor: color,
                maskImage: `url(${icon})`,
                WebkitMaskImage: `url(${icon})`,
                maskRepeat: "no-repeat",
                WebkitMaskRepeat: "no-repeat",
                maskSize: "contain",
                WebkitMaskSize: "contain"
            }}
        />

    } else {
        return <img src={icon} alt="section-icon" width={20} height={20} className="nav_icon" />
    }
};

// const DASHBOARD_STATIC_CHILDREN = [
//     {
//         name: "Home", icon: <HomeIcon width={20} height={20} className="nav_icon" />,
//         route_path: "dashboard"
//     }
// ];

const DATAHUB_STATIC_CHILDREN = [
    {
        name: "Data Hub", icon: <DataHubIcon width={20} height={20} className="nav_icon" />,
        route_path: "data-hub"
    }
];

const FORECASTING_STATIC_CHILDREN = [
    {
        name: "Forecasting", icon: <SalesPlanIcon width={20} height={20} className="nav_icon" />,
        route_path: "form-module/forecasting"
    }
];

const Sidebar = ({ isShowSidebar, showNav, setShowNav }) => {
    const dispatch = useDispatch();
    let formList = useSelector((state) => state?.forms);
    let sidebarSectionData = useSelector((state) => state?.sidebar);
    let manageModules = formList?.manageModules || [];
    let tableData = formList?.tableData || [];
    let userPermissionData = getItem('userPermission')?.adminLevel;
    let currentUser = getItem("user") || {};
    // const [routes, setRoutes] = useState([]);
    const navigate = useNavigate();
    const location = useLocation();
    // let [sideBarData, setSideBarData] = useState([]);
    let [showCreateSectionModal, setShowCreateSectionModal] = useState(false);
    let [sectionName, setSectionName] = useState('');
    let [url, setUrl] = useState('');
    let [color, setColor] = useState("");

    const [activeKey, setActiveKey] = useState(null);

    useEffect(() => {
        dispatch(getSidebarSectionListStart());
    }, []);

    useEffect(() => {
        if ((formList?.isManageModuleApiError || formList?.isManageModuleApiCalled) && formList?.navbarList?.length) {
            dispatch(getAllFormModuleStart());
        }
    }, [formList?.isManageModuleApiError, formList?.isManageModuleApiCalled]);

    const isActive = (path) => {
        return location.pathname === path;
    };

    let salesArr = [
        {
            name: "Quotes",
            icon: '<QuotesIcon width={20} height={20} className="nav_icon" />',
            route_path: ""
        },
        {
            name: "Leads",
            icon: '<LeadsIcon width={20} height={20} className="nav_icon" />',
            route_path: ""
        },
        {
            name: "Accounts",
            icon: '<AccountsIcon width={20} height={20} className="nav_icon" />',
            route_path: ""
        }]


    // useEffect(() => {
    //     let routes = [
    //         {
    //             name: "Dashboard", icon: <DashboardIcon width={20} height={20} />,
    //             children: [
    //                 {
    //                     name: "Marketing", icon: <MarketingIcon width={20} height={20} className="nav_icon" />,
    //                     route_path: "dashboard"
    //                 },
    //                 {
    //                     name: "Data Hub", icon: <DataHubIcon width={20} height={20} className="nav_icon" />,
    //                     route_path: "data-hub"
    //                 },
    //                 {
    //                     name: "Prospects", icon: <ProspectusIcon width={20} height={20} className="nav_icon" />,
    //                     route_path: "settings/personal-settings"
    //                 },
    //                 {
    //                     name: "Campaign", icon: <CampaignIcon width={20} height={20} className="nav_icon" />,
    //                     route_path: "settings/users"
    //                 },
    //             ]
    //         },
    //         {
    //             name: "Sales", icon: <SalesIcon width={20} height={20} />,
    //             children: [
    //                 {
    //                     name: "Quotes", icon: <QuotesIcon width={20} height={20} className="nav_icon" />,
    //                     route_path: "settings/profiles"
    //                 },
    //                 {
    //                     name: "Sales Plan", icon: <SalesPlanIcon width={20} height={20} className="nav_icon" />,
    //                     route_path: "settings/roles-and-sharing"
    //                 },
    //                 {
    //                     name: "Leads", icon: <LeadsIcon width={20} height={20} className="nav_icon" />,
    //                     route_path: "settings/login-history"
    //                 },
    //                 {
    //                     name: "Accounts", icon: <AccountsIcon width={20} height={20} className="nav_icon" />,
    //                     route_path: "settings/audit-log"
    //                 },
    //                 {
    //                     name: "Contacts", icon: <ContactsIcon width={20} height={20} className="nav_icon" />,
    //                     route_path: "settings/territories"
    //                 },
    //                 {
    //                     name: "Deals", icon: <DealsIcon width={20} height={20} className="nav_icon" />,
    //                     route_path: "form-module"
    //                 },
    //             ]
    //         },
    //         {
    //             name: "Activities", icon: <ActivitiesIcon width={20} height={20} />,
    //             children: [
    //                 {
    //                     name: "Tasks", icon: <TasksIcon width={20} height={20} className="nav_icon" />,
    //                     route_path: "settings/email"
    //                 },
    //                 {
    //                     name: "Calls", icon: <CallsIcon width={20} height={20} className="nav_icon" />,
    //                     route_path: "settings/business-messaging"
    //                 },
    //                 {
    //                     name: "Meeting", icon: <MeetingsIcon width={20} height={20} className="nav_icon" />,
    //                     route_path: "settings/notification-sms"
    //                 },
    //             ]
    //         },
    //         {
    //             name: "O2C", icon: <O2cIcon width={20} height={20} />,
    //             children: [
    //                 {
    //                     name: "Sales Order", icon: <SalesOrderIcon width={20} height={20} className="nav_icon" />,
    //                     route_path: "settings/company-settings"
    //                 },
    //                 {
    //                     name: "Invoices", icon: <InvoicesIcon width={20} height={20} className="nav_icon" />,
    //                     route_path: "workflow-rules"
    //                 },
    //             ]
    //         },
    //         {
    //             name: "Services", icon: <ServicesIcon width={20} height={20} />,
    //             children: [
    //                 {
    //                     name: "Cases", icon: <CasesIcon width={20} height={20} className="nav_icon" />,
    //                     route_path: "ai"
    //                 },
    //             ]
    //         },
    //         {
    //             name: "Master", icon: <MasterIcon width={20} height={20} />,
    //             children: [
    //                 {
    //                     name: "Product Master", icon: <ProductMasterIcon width={20} height={20} className="nav_icon" />,
    //                     route_path: "integration-api"
    //                 },
    //                 {
    //                     name: "Price Books", icon: <PriceBookIcon width={20} height={20} className="nav_icon" />,
    //                     route_path: "subscription"
    //                 },
    //             ]
    //         },
    //         // { name: "Add Modules", icon: <LuPlusSquare size={18} />, }
    //     ];

    //     routes = routes.map(section => {
    //         if (section.name === "Security Control" && section.children) {
    //             return {
    //                 ...section,
    //                 children: section.children.filter(
    //                     (child) => {
    //                         if (child.name === "Profiles" && userPermissionData?.find(u => u.key === "profilesAccess")?.permision === false) return false;
    //                         if (child.name === "Roles and Sharing" && userPermissionData?.find(u => u.key === "rolesAndSharingAccess")?.permision === false) return false;
    //                         return true;
    //                         // child.name !== "Profiles" &&
    //                         // child.name !== "Roles and Sharing"
    //                     })
    //             };
    //         }
    //         return section;
    //     });

    //     routes = routes.map(x => {
    //         const children =
    //             x.children?.map(y => ({
    //                 ...y,
    //                 isActive: isActive(Utils.getNavigationUrl(y.route_path))
    //             })) || [];

    //         return {
    //             ...x,
    //             children,
    //             isActive: children.some(child => child.isActive)
    //         };
    //     });

    //     // console.log(routes);
    //     setSideBarData(routes);
    // }, [location.pathname]);

    useEffect(() => {
        if (showNav) setFlyoutIndex(null);
    }, [showNav]);

    const [flyoutIndex, setFlyoutIndex] = useState(null);
    const [isPinned, setIsPinned] = useState(false);

    const handleHover = (index) => {
        if (!isPinned) {
            setFlyoutIndex(index);
        }
    };

    const handleLeave = () => {
        if (!isPinned) {
            setFlyoutIndex(null);
        }
    };

    const handlePin = (index) => {
        if (flyoutIndex === index && isPinned) {
            // unpin
            setFlyoutIndex(null);
            setIsPinned(false);
        } else {
            // pin new
            setFlyoutIndex(index);
            setIsPinned(true);
        }
    };

    // 
    useEffect(() => {
        dispatch(getAllFormModuleTableDataStart());
    }, []);

    // useEffect(() => {
    //     const DASHBOARD_STATIC_CHILDREN = [
    //         {
    //             name: "Home", icon: <DashboardIcon width={20} height={20} className="nav_icon" />,
    //             route_path: "dashboard"
    //         }
    //     ];

    //     const DATAHUB_STATIC_CHILDREN = [
    //         {
    //             name: "Data Hub", icon: <DataHubIcon width={20} height={20} className="nav_icon" />,
    //             route_path: "data-hub"
    //         }
    //     ];


    //     // const groupedBySection = tableData.reduce((acc, item) => {
    //     //     const section = item.sidebar_section;

    //     //     if (!acc[section]) {
    //     //         acc[section] = [];
    //     //     }

    //     //     acc[section].push(item);
    //     //     return acc;
    //     // }, {});

    //     // const getPath = (id, name) => {
    //     //     if (name === "Sales Plan") {
    //     //         return navigate(Utils.getNavigationUrl(id));
    //     //     } else {
    //     //         return navigate(Utils.getNavigationUrl(`form-module/sub-form/${id}`));
    //     //     }
    //     // };

    //     // const sidebarMenu = Object.keys(groupedBySection).map(section => ({
    //     //     name: section,
    //     //     // icon: getSectionIcon(section), // optional
    //     //     children: groupedBySection[section].map(item => ({
    //     //         name: item.name,
    //     //         // route_path: `/module/${item._id}`,
    //     //         route_path: `form-module/sub-form/${item._id}`,
    //     //         // icon: getItemIcon(item.name) // optional
    //     //     }))
    //     // }));

    //     // const options = [
    //     //     { value: "Dashboard", label: "Dashboard" },
    //     //     { value: "Sales", label: "Sales" },
    //     //     { value: "Activities", label: "Activities" },
    //     //     { value: "O2C", label: "O2C" },
    //     //     { value: "Services", label: "Services" },
    //     //     { value: "Master", label: "Master" }
    //     // ];

    //     if (sidebarSectionData?.sectionData?.length > 0) {
    //         const options = sidebarSectionData?.sectionData?.map(item => ({
    //             value: item.section_name,
    //             label: item.section_name
    //         }));

    //         const sidebarMenu = options.map(section => {
    //             let children = [];

    //             if (section.value === "Dashboard") {
    //                 children = [...DASHBOARD_STATIC_CHILDREN];
    //             }

    //             if (section.value === "Marketing") {
    //                 children = [...DATAHUB_STATIC_CHILDREN];
    //             }

    //             const apiChildren = tableData
    //                 .filter(item => item.sidebar_section === section.value)
    //                 .map(item => ({
    //                     name: item.name,
    //                     route_path: `form-module/sub-form/${item._id}`,
    //                     icon: getItemIcon(item.name)
    //                 }));
    //             console.log("api children", apiChildren);

    //             // sorting based on manageModules order

    //             children = [...children, ...apiChildren];

    //             return {
    //                 name: section.label,
    //                 icon: getSectionIcon(section.value),
    //                 children
    //             };

    //             // const children = tableData
    //             //     .filter(item => item.sidebar_section === section.value)
    //             //     .map(item => ({
    //             //         name: item.name,
    //             //         route_path: `form-module/sub-form/${item._id}`,
    //             //         icon: getItemIcon(item.name)
    //             //     }));

    //             // return {
    //             //     name: section.label,
    //             //     icon: getSectionIcon(section.value),
    //             //     children
    //             // };
    //         });

    //         setSideBarData(sidebarMenu);
    //     }
    // }, [tableData, sidebarSectionData?.sectionData]);


    // const normalize = (name = "") => name.trim().toLowerCase();
    // useEffect(() => {
    //     const DASHBOARD_STATIC_CHILDREN = [
    //         {
    //             name: "Home", icon: <DashboardIcon width={20} height={20} className="nav_icon" />,
    //             route_path: "dashboard"
    //         }
    //     ];

    //     const DATAHUB_STATIC_CHILDREN = [
    //         {
    //             name: "Data Hub", icon: <DataHubIcon width={20} height={20} className="nav_icon" />,
    //             route_path: "data-hub"
    //         }
    //     ];

    //     if (sidebarSectionData?.sectionData?.length > 0) {
    //         const options = sidebarSectionData?.sectionData?.map(item => ({
    //             value: item.section_name,
    //             label: item.section_name
    //         }));

    //         const sidebarMenu = options.map(section => {
    //             let children = [];

    //             if (section.value === "Dashboard") {
    //                 children = [...DASHBOARD_STATIC_CHILDREN];
    //             }

    //             if (section.value === "Marketing") {
    //                 children = [...DATAHUB_STATIC_CHILDREN];
    //             }

    //             const manageModuleOrderMap = manageModules.reduce((acc, item, index) => {
    //                 acc[item.name.trim()] = index;
    //                 return acc;
    //             }, {});

    //             const apiChildren = tableData
    //                 .filter(item => item.sidebar_section === section.value)
    //                 .map(item => ({
    //                     name: item.name,
    //                     route_path: `form-module/sub-form/${item._id}`,
    //                     icon: getItemIcon(item.name)
    //                 }))
    //                 .sort((a, b) => {
    //                     return (
    //                         (manageModuleOrderMap[normalize(a.name)] ?? 999) -
    //                         (manageModuleOrderMap[normalize(b.name)] ?? 999)
    //                     );
    //                 });
    //             console.log("api children", apiChildren);

    //             // sorting based on manageModules order

    //             children = [...children, ...apiChildren];

    //             return {
    //                 name: section.label,
    //                 icon: getSectionIcon(section.value),
    //                 children
    //             };
    //         });
    //         setSideBarData(sidebarMenu);
    //     }
    // }, [tableData, sidebarSectionData?.sectionData]);

    const normalize = (name = "") => name.trim().toLowerCase();
    // useEffect(() => {
    const sideBarData = useMemo(() => {
        if (!sidebarSectionData?.sectionData?.length) return [];

        const manageModuleOrderMap = manageModules.reduce((acc, item, index) => {
            acc[normalize(item.name)] = index;
            return acc;
        }, {});

        return sidebarSectionData.sectionData.map(sectionItem => {
            let children = [];

            // if (sectionItem.section_name === "Dashboard") {
            //     children.push(...DASHBOARD_STATIC_CHILDREN);
            // }
            const sectionPath = Utils.getNavigationUrl(
                sectionItem.section_name === "Dashboard" ? "dashboard" : ""
            );

            if (sectionItem.section_name === "Marketing") {
                // children.push(...DATAHUB_STATIC_CHILDREN, ...FORECASTING_STATIC_CHILDREN);
                children.push(
                    ...DATAHUB_STATIC_CHILDREN.map(child => ({
                        ...child,
                        isActive: location.pathname === Utils.getNavigationUrl(child.route_path)
                    })),
                    ...FORECASTING_STATIC_CHILDREN.map(child => ({
                        ...child,
                        isActive: location.pathname === Utils.getNavigationUrl(child.route_path)
                    }))
                );
            }
            const apiChildren = tableData
                .filter(item => item.sidebar_section === sectionItem.section_name)
                .map(item => {
                    const childPath = Utils.getNavigationUrl(`form-module/sub-form/${item._id}`);
                    return {
                        name: item.name,
                        route_path: `form-module/sub-form/${item._id}`,
                        icon: getItemIcon(item.icon, item.color),
                        // Check if current URL matches this item's path
                        isActive: location.pathname === childPath
                    };
                })
                .sort((a, b) => {
                    return (
                        (manageModuleOrderMap[normalize(a.name)] ?? 999) -
                        (manageModuleOrderMap[normalize(b.name)] ?? 999)
                    );
                });
            // let obj = {
            //     name: sectionItem.section_name,
            //     icon: getSectionIcon(sectionItem.icon, sectionItem.color),
            // };

            // if (sectionItem?.section_name !== "Dashboard") {
            //     obj.children = [...children, ...apiChildren];
            // }
            // return obj;
            const allChildren = [...children, ...apiChildren];

            // AUTO-EXPAND LOGIC: Check if any child is currently active
            const hasActiveChild = allChildren.some(child => child.isActive);

            return {
                name: sectionItem.section_name,
                icon: getSectionIcon(sectionItem.icon, sectionItem.color),
                isActive: location.pathname === sectionPath || hasActiveChild, // Highlight parent if child is active
                hasActiveChild,
                children: allChildren
            };

            // return {
            //     name: sectionItem.section_name,
            //     icon: getSectionIcon(sectionItem.icon),
            //     children: [...children, ...apiChildren]
            // };
        });

        // setSideBarData(sidebarMenu);
    }, [tableData, sidebarSectionData, manageModules, location.pathname]);

    useEffect(() => {
        // Find the index of the section that contains the active child
        const activeIndex = sideBarData.findIndex(section => section.hasActiveChild);
        if (activeIndex !== -1) {
            const newKey = activeIndex.toString();
            // Only update if the key is different from current state
            if (activeKey !== newKey) {
                setActiveKey(newKey);
            }
            // setActiveKey(activeIndex.toString());
        }
    }, [location.pathname]);


    useEffect(() => {
        if (sidebarSectionData?.createSectionStatus === true) {
            setSectionName('');
            setUrl('');
            setColor('');
            dispatch(getSidebarSectionListStart());
        }
        if (sidebarSectionData?.createSectionStatus === false) {
            toast.error(sidebarSectionData?.message, {
                autoClose: 2000,
            })
        }
    }, [sidebarSectionData?.createSectionStatus]);

    const handleSave = () => {
        let payload = {
            "section_name": sectionName,
            "icon": url,
            "color": color
        };
        dispatch(createSidebarSectionStart(payload));
        setShowCreateSectionModal(false);
    }

    return (
        <React.Fragment>
            <Loader isVisible={sidebarSectionData?.isLoading} />
            <Toast />
            <div className={`border-end l-navbar ${showNav ? 'show' : ''}`}>
                <nav className={`nav d-flex flex-column h-100 flex-nowrap ${showNav ? 'overflow-hidden' : ''}`}>
                    {/* Header Section */}
                    <div className="nav_link mb-1 flex-shrink-0">
                        <span className={showNav ? 'position-absolute end-0 translate-middle-x' : ''}
                            role="button" onClick={() => setShowNav(!showNav)}>
                            {showNav ?
                                <TbSquareArrowLeft className="nav_icon" title="Hide side menu" />
                                :
                                <TbSquareArrowRight className="nav_icon" title="Show side menu" />
                            }
                        </span>
                        {showNav && <span className="nav_name fw-semibold">Modules</span>}
                    </div>
                    {/* <div className="nav_list flex-grow-1 overflow-y-auto overflow-x-hidden" id="mainSidebarParentBox">
                        {sideBarData?.length > 0 && (
                            sideBarData?.map((x, i) => (<React.Fragment key={i}>
                                <button type="button" 
                                    className={`btn btn-link link-dark d-grid nav_link justify-content-start ${x?.isActive ? 'active' : ''}`}
                                    data-bs-toggle="collapse" data-bs-target={`#collapseMainSidebar${i}`}
                                    aria-expanded={x?.isActive} aria-controls={`collapseMainSidebar${i}`}>
                                    {showNav && <IoCaretForwardOutline />}
                                    {x?.icon}
                                    {showNav && <span className="flex-fill text-start">{x?.name}</span>}
                                </button>
                                {x?.children?.length > 0 && (
                                    <div className={`collapse ms-3 pt-3 ${x?.isActive ? "show" : ""}`} id={`collapseMainSidebar${i}`} data-bs-parent="#mainSidebarParentBox">
                                        {x?.children?.map((y => (
                                            <a key={y?.route_path} onClick={() => navigate(Utils.getNavigationUrl(y?.route_path))} 
                                            className={`nav_link ${y?.isActive ? 'active' : ''}`} aria-current="true">
                                                <LuUserCheck className="nav_icon" />
                                                {showNav && <span className="nav_name">{y?.name}</span>}
                                            </a>
                                        )))}
                                    </div>)}
                            </React.Fragment>))
                        )}
                    </div> */}
                    <Accordion className={`nav_list flex-grow-1 ${showNav ? 'overflow-y-auto overflow-x-hidden' : ''}`}
                        flush
                        activeKey={activeKey}
                        onSelect={(k) => setActiveKey(k)}>
                        {sideBarData?.length > 0 && (
                            sideBarData?.map((x, i) => (
                                <div className="px-3 position-relative" key={i}>
                                    <ContextAwareToggle
                                        name={x?.name}
                                        eventKey={i}
                                        showNav={showNav}
                                        setActiveKey={setActiveKey}
                                        activeKey={activeKey}
                                        onCollapsedClick={setFlyoutIndex}
                                        onHover={handleHover}
                                        onLeave={handleLeave}
                                        onClickPin={handlePin}
                                        isActive={x?.isActive}
                                        isFlyoutActive={!showNav && flyoutIndex === i}>
                                        {x?.icon}
                                        {showNav && <span className="flex-fill text-start">{x?.name}</span>}
                                    </ContextAwareToggle>
                                    {x?.children?.length > 0 && (<>
                                        {showNav && (
                                            <Accordion.Collapse eventKey={i} className={`ms-3 pt-0`}>
                                                <div className={`${showNav ? 'd-block' : 'd-none'}`}>
                                                    {x?.children?.map((y => (
                                                        <a key={y?.route_path}
                                                            onClick={() => { navigate(Utils.getNavigationUrl(y?.route_path)); setFlyoutIndex(null); }}
                                                            className={`nav_link mb-1 ${y?.isActive ? 'active' : ''}`}
                                                            role="button">
                                                            {/* <LuUserCheck className="nav_icon" /> */}
                                                            {y?.icon}
                                                            <span className="nav_name">{y?.name}</span>
                                                        </a>
                                                    )))}
                                                </div>
                                            </Accordion.Collapse>
                                        )}
                                        {/* FLYOUT MENU */}
                                        {!showNav && flyoutIndex === i && (
                                            <div
                                                className={`sidebar-flyout ${isPinned ? 'pinned' : ''}`}
                                                onMouseEnter={() => isPinned && setFlyoutIndex(i)}
                                                onMouseLeave={() => !isPinned && setFlyoutIndex(null)}
                                            >
                                                {x.children.map(y => (
                                                    <a key={y?.route_path}
                                                        role="button"
                                                        className="flyout-item"
                                                        onClick={() => {
                                                            navigate(Utils.getNavigationUrl(y?.route_path));
                                                            setFlyoutIndex(null);
                                                            setIsPinned(false);
                                                        }}
                                                    >
                                                        {y?.icon}
                                                        <span>{y?.name}</span>
                                                    </a>
                                                ))}
                                            </div>
                                        )}
                                    </>)}
                                </div>
                            ))
                        )}
                    </Accordion>
                    <div className="mt-auto flex-shrink-0 border-top ps-3">
                        <Button variant="link"
                            className={`link-primary d-flex w-100 px-2 nav_link justify-content-${showNav ? 'start' : 'center'} mb-1`}
                            onClick={() => setShowCreateSectionModal(true)}>
                            {/* <LuPlusSquare className="nav_icon" /> */}
                            {showNav && <span className="nav_name">Add Sidebar Section</span>}
                        </Button>
                        <Button variant="link"
                            className={`link-primary d-flex w-100 px-2 nav_link justify-content-${showNav ? 'start' : 'center'} mb-1`}
                            onClick={() => navigate(Utils.getNavigationUrl('form-module/create'))}>
                            {/* <LuPlusSquare className="nav_icon" /> */}
                            {showNav && <span className="nav_name">Add Modules</span>}
                        </Button>
                    </div>
                    {/* Footer Section */}
                    {/* <div className="border-top mt-auto flex-shrink-0">
                        <a href="/" className="nav_link mb-2">
                            <LuLogOut className="nav_icon" />
                            {showNav && <span className="nav_name">SignOut</span>}
                        </a>
                    </div> */}
                </nav>
            </div>
            {showCreateSectionModal &&
                <CreateSectionModal
                    show={showCreateSectionModal}
                    handleClose={() => { setShowCreateSectionModal(false); setSectionName(''); setUrl(''); setColor('') }}
                    sectionName={sectionName}
                    setSectionName={setSectionName}
                    handleSave={() => handleSave()}
                    url={url}
                    setUrl={setUrl}
                    color={color}
                    setColor={setColor}
                />
            }
        </React.Fragment>
    );
}

export default Sidebar;